var map = {
	"./barring.jpg": "0dd0",
	"./bg.jpg": "3721",
	"./catalogue.jpg": "5dc8",
	"./content-bundles.jpg": "38c4",
	"./customer-contract.jpg": "83f0",
	"./order.jpg": "76ff",
	"./payment-transactions.jpg": "a487",
	"./pin-protection.jpg": "a27a",
	"./recharge-transactions.jpg": "7640",
	"./stock.jpg": "75308",
	"./unbarring.jpg": "eb01"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f7d";